import { RootState } from 'store/store';

const selectProductSets = (state: RootState) => state.FurnitureAndEquipment.productSets;
const selectProductRentalCart = (state: RootState) => state.FurnitureAndEquipment.productRentalCart;
const selectProductRentalCartItems = (state: RootState) => state.FurnitureAndEquipment.productRentalCart?.items;
const selectProductSetRentalOrders = (state: RootState) => state.FurnitureAndEquipment.productSetRentalOrders;
const selectProductSetRentalInventory = (state: RootState) => state.FurnitureAndEquipment.productSetRentalInventory;
const selectHasFurnitureAndEquipment = (state: RootState) => {
  const inventory = state.FurnitureAndEquipment.productSetRentalInventory;
  return !!inventory && Object.keys(inventory).length > 0;
};
const selectDeliveredProductSetRentalOrders = (state: RootState) => {
  const productSetRentalOrders = selectProductSetRentalOrders(state);
  return productSetRentalOrders?.filter(order =>
    order.product_set_rental_groups.every(group => group.status === 'completed')
  );
};
const selectNonDeliveredProductSetRentalOrders = (state: RootState) => {
  const productSetRentalOrders = selectProductSetRentalOrders(state);
  return productSetRentalOrders?.filter(order =>
    order.product_set_rental_groups.some(group => group.status === 'pending' || group.status === 'scheduled')
  );
};
const selectSalesTaxRate = (state: RootState) => state.FurnitureAndEquipment.productRentalCart?.sales_tax_rate;
const selectTenancyServices = (state: RootState) => state.Tenancy.tenancy_services;
export {
  selectProductSets,
  selectProductRentalCart,
  selectProductRentalCartItems,
  selectProductSetRentalOrders,
  selectProductSetRentalInventory,
  selectHasFurnitureAndEquipment,
  selectSalesTaxRate,
  selectDeliveredProductSetRentalOrders,
  selectNonDeliveredProductSetRentalOrders,
  selectTenancyServices
};
